<template>
  <div class="card modal-card width-960">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">
              {{ $t('ajoutPresseDcf.popupSelection.selectionParution') }}
            </h1>
          </div>
        </div>
      </div>
      <div class="card-content">
        <selectionParution :produit="ligneCommande.produit"
                           :onlyOneSelect="true"
                           :emplacement-id="getEmplacementOfEncart"
                           :surface-id="getSurfaceOfEncart"
                           :parutionsSelected="parutionsSelected">
        </selectionParution>
        <footer>
          <b-field>
            <div class="is-pulled-left boutonAction">
              <a class="button" @click="$parent.close()">
                {{ $t('general.button.cancel')}}
              </a>
            </div>
            <div class="is-pulled-left boutonAction">
              <a class="button is-addOrEdit" @click="applyNewParutionId">
                {{ $t('general.button.apply') }}
              </a>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import selectionParution
  from '@/components/devisCommandes/editionDevisCommande/ajoutLigneViaEcranAjout/selectionParution';
import { createNamespacedHelpers } from 'vuex';
import {
  INIT_PARUTION_SELECTED,
  SET_PARUTIONS_SELECTED,
} from '@/store/modules/presse/parution-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { CATEGORIE_ENCART } from '@/configuration/catalogue/produitConf';

const Parution = createNamespacedHelpers('parution');

export default {
  name: 'popUpChangeParution',
  props: {
    ligneCommande: {
      type: Object,
      required: true,
    },
  },
  components: {
    selectionParution,
  },
  computed: {
    ...Parution.mapGetters({
      parutionsSelected: 'parutionsSelected',
    }),
    getSurfaceOfEncart() {
      const encartFound = this.ligneCommande.lignesCommande
        .find((el) => el.typeProduit === CATEGORIE_ENCART);
      if (encartFound) {
        return encartFound.produit.produitEncart.surfaceId;
      }
      return null;
    },
    getEmplacementOfEncart() {
      const encartFound = this.ligneCommande.lignesCommande
        .find((el) => el.typeProduit === CATEGORIE_ENCART);
      if (encartFound) {
        return encartFound.produit.produitEncart.emplacementId;
      }
      return null;
    },
  },
  methods: {
    ...Parution.mapMutations({
      setParutionsSelected: SET_PARUTIONS_SELECTED,
      initParutionSelected: INIT_PARUTION_SELECTED,
    }),
    applyNewParutionId() {
      let parutionFind = null;
      if (this.parutionsSelected.length >= 1) {
        parutionFind = this.parutionsSelected[0];
      }
      if (parutionFind) {
        this.ligneCommande.parutionId = parutionFind.id;
        this.ligneCommande.parution = parutionFind;
        this.ligneCommande.dateDebut = parutionFind.dateParution;
        this.ligneCommande.dateFin = parutionFind.dateParution;
      } else {
        this.ligneCommande.parution = null;
        this.ligneCommande.parutionId = null;
        this.ligneCommande.dateDebut = null;
        this.ligneCommande.dateFin = null;
      }
      this.$emit('applyParution');
      this.$emit('close');
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.initParutionSelected([]);
      if (this.ligneCommande.parutionId) {
        await this.setParutionsSelected(this.ligneCommande.parution);
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
